export default "__VITE_ASSET__rMaKJViI__"